var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"11","width":"2","height":"24","key":0}),React.createElement("rect",{"y":"13","width":"2","height":"24","transform":"rotate(-90 0 13)","key":1})]);
}

PlusInline.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
